import { render, staticRenderFns } from "./AppointmentFormModal.vue?vue&type=template&id=3abaf47e&scoped=true&"
import script from "./AppointmentFormModal.vue?vue&type=script&lang=js&"
export * from "./AppointmentFormModal.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentFormModal.vue?vue&type=style&index=0&id=3abaf47e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abaf47e",
  null
  
)

export default component.exports